import { SurveyAction, SurveyActionType } from '../actions/survey';
import { QuestionsCollection, InteractiveQuestion } from '../api/models/survey';

export interface SurveyNamespace {
    questionsCollection: QuestionsCollection;
    interactiveQuestions: Array<InteractiveQuestion>;
}

export interface WithSurveyNamespace {
    survey?: SurveyNamespace;
}

export const surveyReducer = (
    state: SurveyNamespace = {
        questionsCollection: {},
        interactiveQuestions: [],
    },
    action: SurveyAction,
): SurveyNamespace => {
    switch (action.type) {
        case SurveyActionType.initSurveys:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};
